var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCompass = function SvgCompass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8m126.14 148.05-66 144.35a31.94 31.94 0 0 1-15.77 15.77l-144.34 66c-16.65 7.61-33.81-9.55-26.2-26.2l66-144.35a31.94 31.94 0 0 1 15.77-15.77l144.34-66c16.66-7.6 33.81 9.55 26.2 26.2",
    style: {
      opacity: 0.3
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m356 129.85-144.34 66a31.94 31.94 0 0 0-15.77 15.77l-66 144.35c-7.61 16.65 9.55 33.81 26.2 26.2l144.34-66a31.94 31.94 0 0 0 15.77-15.77l66-144.35c7.55-16.65-9.6-33.8-26.2-26.2m-77.37 148.77a32 32 0 1 1 0-45.25 32 32 0 0 1 0 45.25",
    className: "compass_svg__fa-primary"
  })));
};
export default SvgCompass;